// Page « QR code faire-part de mariage » (référencement). En français : elle vise
// « qr code mariage gratuit », « faire part mariage qr code », « qr code mariage rsvp ».

import { Template } from '../common/TemplateCard';
import { FaqItem } from '../common/GuideLayout';

export const UPDATED = '2026-10-15';
export const READING_MINUTES = 6;

export const TOC = [
  { id: 'pourquoi', label: 'Pourquoi un QR code sur le faire-part ?' },
  { id: 'creer', label: 'Créer son QR code en 4 étapes' },
  { id: 'placer', label: 'Taille, emplacement et couleurs' },
  { id: 'phrases', label: 'Quelle phrase écrire à côté ?' },
  { id: 'expiration', label: 'Attention aux QR codes qui expirent' },
  { id: 'tester', label: 'Tester avant d’imprimer' },
  { id: 'faq', label: 'Questions fréquentes' },
];

export const WHY = [
  {
    title: 'Pas de carton ni de timbre',
    text: 'Vos invités répondent depuis leur téléphone, sans rien renvoyer par la poste.',
  },
  {
    title: 'Des réponses qui arrivent seules',
    text: 'Chaque réponse s’ajoute à votre liste d’invités : plus rien à recopier.',
  },
  {
    title: 'Toutes les infos au même endroit',
    text: 'Date, lieu, programme des événements : votre page d’invitation les rassemble.',
  },
  { title: 'Un faire-part plus léger', text: 'Le QR code remplace les cartons d’information et le carton réponse.' },
];

export const STEPS = [
  {
    title: 'Créez votre page de réponse',
    text: 'Gratuitement, en deux minutes : vos prénoms, votre date, vos événements et votre liste d’invités. C’est vers elle que mènera le QR code.',
  },
  {
    title: 'Téléchargez le QR code',
    text: 'En un clic, en image PNG à fond transparent : il se pose sur n’importe quel fond de faire-part.',
  },
  {
    title: 'Ajoutez-le à votre faire-part',
    text: 'Dans Canva, chez votre imprimeur ou votre papetier : c’est une simple image à placer, comme un logo.',
  },
  {
    title: 'Testez avant d’imprimer',
    text: 'Scannez l’épreuve avec plusieurs téléphones : chacun doit arriver sur votre page.',
  },
];

export const PLACEMENT = [
  'Au moins 2 cm de côté : en dessous, certains téléphones peinent à le lire, surtout de loin.',
  'Foncé sur fond clair et uni. Évitez de le poser sur une photo, une texture ou un dégradé.',
  'Laissez une marge blanche autour, sans texte ni motif qui le touche.',
  'En bas du faire-part, au dos, ou sur un petit carton glissé dans l’enveloppe : il doit rester discret.',
  'Écrivez aussi l’adresse du site en clair, pour ceux qui préfèrent la taper.',
];

export const PHRASES: Template[] = [
  { title: 'Simple', text: 'Scannez pour nous répondre avant le [date].' },
  {
    title: 'Complète',
    text: 'Toutes les informations et votre réponse, avant le [date] : scannez ce QR code ou rendez-vous sur [adresse du site].',
  },
  {
    title: 'Chaleureuse',
    text: 'Un petit scan pour nous dire si vous serez des nôtres. Réponse souhaitée avant le [date] !',
  },
  { title: 'Bilingue', text: 'Scannez pour répondre avant le [date] · Scan to reply by [date]' },
];

export const TEST = [
  'Scannez l’épreuve papier, pas seulement le fichier à l’écran.',
  'Essayez avec un iPhone et un Android, et de près comme à 30 cm.',
  'Vérifiez que la page s’ouvre bien sur la vôtre, à vos prénoms.',
  'Faites une réponse test avec un invité fictif, puis supprimez-le.',
];

export const FAQ: FaqItem[] = [
  {
    q: 'Comment créer un QR code gratuit pour son faire-part de mariage ?',
    a: 'Créez votre page de réponse gratuite, puis téléchargez son QR code en image PNG. Il suffit ensuite de l’ajouter au faire-part dans Canva ou chez votre imprimeur, sur au moins 2 cm de côté.',
  },
  {
    q: 'Un QR code de mariage peut-il expirer ?',
    a: 'Un QR code qui contient directement l’adresse de votre site n’expire jamais. Ceux de certains générateurs « gratuits » passent par un lien de redirection qui peut être désactivé au bout de quelques semaines, ou devenir payant.',
  },
  {
    q: 'Quelle taille pour un QR code sur un faire-part ?',
    a: 'Au moins 2 cm de côté, avec une marge blanche autour. Plus grand, il se lit plus facilement, mais 2 à 3 cm suffisent sur un faire-part classique.',
  },
  {
    q: 'Faut-il une application pour scanner le QR code ?',
    a: 'Non : l’appareil photo des iPhone et de la plupart des téléphones Android lit les QR codes directement. Il suffit de viser le code et de toucher le lien qui apparaît.',
  },
  {
    q: 'Peut-on ajouter un QR code à un faire-part déjà imprimé ?',
    a: 'Oui : imprimez-le sur un petit carton ou une étiquette autocollante, avec la phrase de réponse, et glissez-le dans l’enveloppe.',
  },
  {
    q: 'Vers quoi doit mener le QR code ?',
    a: 'Vers une page où vos invités peuvent à la fois lire les informations du mariage et répondre. Une page RSVP Please le fait, gratuitement.',
  },
];
